import { render, staticRenderFns } from "./MotivationView.vue?vue&type=template&id=33b929ea"
import script from "./MotivationView.vue?vue&type=script&lang=js"
export * from "./MotivationView.vue?vue&type=script&lang=js"
import style0 from "./MotivationView.vue?vue&type=style&index=0&id=33b929ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports